import Context from "../../../context/Context";
import OfficePlan from "../OfficePlan";
import * as serviceUtil from "../serviceUtil";
import * as sourceUtil from "../sourceUtil";

export const TIMEOUT = (60000 * 30);

export function applyEdits(task,transactionInfo) {
  const promise = new Promise((resolve,reject) => {

    const edits = transactionInfo.edits;
    const peopleLayer = sourceUtil.getPeopleLayer();
    const unitsLayer = sourceUtil.getUnitsLayer();
    //const areasTable = OfficePlan.getActive().areasTable;

    const undoManager = OfficePlan.getActive().undoManager;
    const undoTransaction = makeUndoTransaction(transactionInfo);
    //undoManager.addTransaction(undoTransaction);

    const reqInfo = makeApplyEditsRequestInfo(edits,transactionInfo);
    const reqUrl = reqInfo.requestUrl;
    const reqOpts = reqInfo.requestOptions;

    console.log("transaction.applyEdits.transactionInfo",transactionInfo)
    console.log("transaction.applyEdits.requestInfo",reqInfo)

    //if (true) {reject(new Error("test")); return;}

    const esriRequest = Context.instance.lib.esri.esriRequest;
    esriRequest(reqUrl,reqOpts).then(result => {
      console.log("transaction.applyEdits.result",result);
      serviceUtil.validateApplyEditsResponse(result);
      undoManager.addTransaction(undoTransaction);
      const results = (result && result.data);

      // TODO check result for errors?
      // result.data is an array of {id: layerId, updateResults: []}
      //

      if (transactionInfo.afterApplyEdits) {
        transactionInfo.afterApplyEdits(results,undoTransaction,"edit");
      }

    }).then(() => {
      if (transactionInfo.peopleEdits) peopleLayer.refresh();
      if (transactionInfo.unitEdits) unitsLayer.refresh();
      // if (transactionInfo.areasTableEdits) {
      //   return areasTable.refresh();
      // }
    }).then(() => {
      console.log("transaction edits applied................")
      resolve();
    }).catch(ex => {
      reject(ex);
    });

  });
  return promise;
}

export function makeApplyEditsRequestInfo(edits,opts) {
  const unitsLayer = sourceUtil.getUnitsLayer();
  const serviceUrl = unitsLayer.url;
  const editOptions = {
    edits: JSON.stringify(edits),
    rollbackOnFailure: true,
    f: "json"
  };
  if (unitsLayer.gdbVersion) editOptions.gdbVersion = unitsLayer.gdbVersion;
  if (opts && opts.useGlobalIds) editOptions.useGlobalIds = true;
  const transaction = {
    requestUrl: serviceUrl+"/applyEdits",
    requestOptions: {
      query: editOptions,
      method: "post",
      responseType: "json",
      timeout: TIMEOUT
    }
  };
  return transaction;
}

export function makeTransactionInfo() {
  const transactionInfo = {
    peopleEdits: null,
    unitEdits: null,
    areasTableEdits: null,
    edits: [],
    useGlobalIds: true,
    afterApplyEdits: null,
    undo: {
      peopleEdits: null,
      unitEdits: null,
      areasTableEdits: null,
      edits: [],
      useGlobalIds: true
    }
  };
  return transactionInfo;
}

export function makeUndoTransaction(transactionInfo) {
  const edits = transactionInfo.edits;
  const undoEdits = transactionInfo.undo.edits;
  const undoManager = OfficePlan.getActive().undoManager;
  const undoTransaction = undoManager.makeTransaction({
    hadPeopleEdits: !!transactionInfo.peopleEdits,
    hadUnitEdits: !!transactionInfo.unitEdits,
    hadAreasTableEdits: !!transactionInfo.areasTableEdits,
    requestInfo: makeApplyEditsRequestInfo(undoEdits,transactionInfo.undo)
  });
  undoTransaction.redoTransaction = undoManager.makeTransaction({
    hadPeopleEdits: !!transactionInfo.peopleEdits,
    hadUnitEdits: !!transactionInfo.unitEdits,
    hadAreasTableEdits: !!transactionInfo.areasTableEdits,
    requestInfo: makeApplyEditsRequestInfo(edits,transactionInfo)
  });
  undoTransaction.afterApplyEdits = transactionInfo.undo.afterApplyEdits;
  undoTransaction.redoTransaction.afterApplyEdits = transactionInfo.afterApplyEdits;
  console.log("undoTransaction",undoTransaction);
  return undoTransaction;
}
